import {
  DatePicker,
  Input,
  Row,
  Typography,
  Form,
  Space,
  Button,
  message,
  Spin,
  Select,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { formatDate } from "../../common/utils/Utils";
import { ReactComponent as CalenderIcon } from "../../../assests/Mobile_calender_Icon.svg";
import dayjs from "dayjs";
import FloatingInput from "../../common/float-input/FloatInput";
import { useEffect, useState } from "react";
import "./ProductRequestHoldModal.css";
import { useDispatch, useSelector } from "react-redux";
import {
  buyerCampaigns,
  createProductHoldRequest,
  getBuyerCampaigns,
  getCampaignsForPurchase,
  getUserSavedCampaigns,
  moveProductToCampaign,
} from "../../../store/thunks/buyer-thunks/BuyerThunks";
import FloatingSelect from "../../common/floating-select/floatingSelect";
const ProductRequestHoldModal = ({
  campaignDetails,
  selectedProduct,
  productActionType,
  onClose,
}) => {
  const { Text } = Typography;
  const { isHoldLoading } = useSelector((state) => state.productHoldRequest);
  const [form] = Form.useForm();
  const [isHoldRequested, setIsHoldRequested] = useState(false);
  const holdDurationDate = Form.useWatch("hold_duration_date", form);
  const star = <span className="required">*</span>;
  const [buyerComment, setBuyerComment] = useState("");
  const [sellerRejectedReason, setSellerRejectedReason] = useState("");
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const holdApprovalStatus = selectedProduct?.hold_approval_status;
  const {
    buyerCampaignsList,
    isLoading: buyerCampaignsLoader,
    productAvailabilityQuantity,
    buyerSavedCampaignsLoader,
    selectedCampaignDetails,
    getBuyerCampaignsLoading,
    moveProductToCampaignLoading,
  } = useSelector((state) => state.buyerCampaigns);
  const isLoading =
    isHoldLoading || getBuyerCampaignsLoading || moveProductToCampaignLoading;
  const dispatch = useDispatch();
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  useEffect(() => {
    if (productActionType !== "move_to_campaign") return;
    dispatch(
      getBuyerCampaigns({
        value: "saved_campaign",
      }),
    );
  }, [productActionType, dispatch]);
  useEffect(() => {
    form.setFieldsValue({
      campaign_name: campaignDetails?.name || "N/A",
      product_name: selectedProduct?.title || "N/A",
      start_date: selectedProduct?.booked_from
        ? formatDate(selectedProduct?.booked_from)
        : "N/A",
      to_date: selectedProduct?.booked_to
        ? formatDate(selectedProduct?.booked_to)
        : "N/A",
    });
  }, [campaignDetails, selectedProduct, form]);
  useEffect(() => {
    const product = campaignDetails?.booking_array?.find(
      (item) => item?.id === selectedProduct?.id,
    );
    if (product?.hold_approval_status >= 0) {
      setIsHoldRequested(true);
      const buyerComment = product?.hold_comments || "";
      const sellerReason = product?.comment_type || "";
      setBuyerComment(buyerComment);
      setSellerRejectedReason(sellerReason);
      form.setFieldsValue({
        remarks: product?.hold_comments || "N/A",
        hold_duration_date: dayjs(product?.hold_request_end),
        seller_rejected_reason:
          product?.comment_type == "other"
            ? product?.other_comments
            : product?.comment_type,
      });
    }
  }, [campaignDetails, selectedProduct, form]);
  const disabledDate = (current) => {
    if (!current) return false;
    const today = dayjs().startOf("day");
    const bookedTo = selectedProduct?.booked_to
      ? dayjs(selectedProduct.booked_to)
      : null;
    // Disable past dates
    if (current.isBefore(today, "day")) {
      return true;
    }
    // Disable dates after booked_to
    if (bookedTo && current.isAfter(bookedTo, "day")) {
      return true;
    }
    return false;
  };
  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      switch (productActionType) {
        case "hold_request": {
          const payload = {
            product_booking_id: selectedProduct?.id,
            request_period: values.hold_duration_date
              ? values.hold_duration_date.format("DD-MM-YYYY")
              : null,

            ...(values.remarks?.trim() && {
              hold_comments: values.remarks.trim(),
            }),
          };
          dispatch(createProductHoldRequest(payload)).then(({ payload }) => {
            const isSuccess = payload?.status == 1;
            message[isSuccess ? "success" : "error"](
              payload?.message ||
                (isSuccess
                  ? "Hold request sent successfully."
                  : "Failed to send hold request."),
            );
            dispatch(getCampaignsForPurchase());
            form.resetFields();
            onClose();
          });

          break;
        }
        case "move_to_campaign": {
          const selectedCampaign = buyerCampaignsList?.find(
            (campaign) => campaign?.name === values.selected_campaign,
          );
          const payload = {
            campaign_id: selectedCampaign?.id,
            product_booking_id: selectedProduct?.productbookingid,
          };
          dispatch(moveProductToCampaign(payload)).then((res) => {
            if (res?.payload.status == 1) {
              dispatch(buyerCampaigns(selectedCampaignDetails?.id));
              form.resetFields();
              onClose();
            }
          });
          break;
        }
        default:
          console.warn("Unsupported product action type:", productActionType);
      }
    } catch (error) {
      console.log("Validation Error:", error);
    }
  };
  const handleCancel = () => {
    form.resetFields(["hold_date", "remarks"]);
    onClose();
  };
  const campaignOptions = Array.isArray(buyerCampaignsList)
    ? buyerCampaignsList
        ?.filter((campaign) => campaign?.id !== campaignDetails?.id)
        ?.map((campaign) => ({
          id: campaign?.id,
          name: campaign?.name,
        }))
    : [];
  const today = dayjs().startOf("day");
  const bookedTo = selectedProduct?.booked_to
    ? dayjs(selectedProduct.booked_to).startOf("day")
    : null;
  const selectedHoldDate = holdDurationDate
    ? dayjs(holdDurationDate).startOf("day")
    : null;
  const isHoldExpired =
    Number(holdApprovalStatus) === 1 &&
    selectedHoldDate &&
    selectedHoldDate.isBefore(today, "day");
  const holdDurationDays =
    selectedHoldDate && !selectedHoldDate.isBefore(today, "day")
      ? selectedHoldDate.diff(today, "day") + 1
      : 0;

  const formattedBookedTo = bookedTo?.isValid()
    ? bookedTo.format("MMM DD, YYYY")
    : null;

  const formattedSelectedHoldDate = selectedHoldDate?.isValid()
    ? selectedHoldDate.format("MMM DD, YYYY")
    : null;
  const formattedHoldRequestedDayDate = selectedProduct?.hold_request_start
    ? dayjs(selectedProduct.hold_request_start)
        .startOf("day")
        .format("MMM DD, YYYY")
    : null;
  const getHoldStatusMessage = () => {
    const status = Number(selectedProduct?.hold_approval_status);

    if (isHoldExpired) {
      return "Your approved hold request has expired.";
    }

    switch (status) {
      case 0:
        return `Your request to hold this product for ${holdDurationDays} days is pending approval.`;

      case 1:
        return `Your hold request for ${holdDurationDays} days has been approved.`;

      case 2:
        return `Your hold request for ${holdDurationDays} days was rejected.`;

      default:
        return `You are requesting to hold this product for ${holdDurationDays} days.`;
    }
  };
  const showHoldDates =
    [0, 1].includes(holdApprovalStatus) &&
    selectedProduct?.hold_request_start &&
    selectedProduct?.hold_request_end;
  const holdStartDate = showHoldDates
    ? selectedProduct?.hold_request_start
    : selectedHoldDate;
  const holdEndDate = showHoldDates
    ? selectedProduct?.hold_request_end
    : selectedHoldDate;
  return (
    <div>
      <Form form={form} onFinish={handleSubmit}>
        <Row className="maximize-text-row">
          <Text className="market-place-title common-text-101828-18-600">
            {productActionType === "hold_request"
              ? "Request Product Hold"
              : "Move Product to Campaign"}
          </Text>
        </Row>
        <Row className="maximize-sub-text-row">
          <Text className="maximize-text common-text-99a1af-14-500 ">
            {productActionType === "hold_request"
              ? "Fill in the hold details and send request to the seller."
              : "Select a campaign to move this product."}
          </Text>
        </Row>
        <div className="request-hold-form">
          <Row className="campaign-hold-name-row">
            <Text
              className="advertiser-information"
              style={{ color: "#000", textTransform: "none" }}
            >
              Campaign Name
            </Text>
            <Form.Item name="campaign_name">
              <FloatingInput
                className="global-global-billboard-input-feild-re-designed-re-designed"
                customStyles={floatingInputStyles}
                readOnly
              />
            </Form.Item>
          </Row>
          <Row className="campaign-hold-name-row">
            <Text
              className="advertiser-information"
              style={{ color: "#000", textTransform: "none" }}
            >
              Product Name
            </Text>
            <Form.Item name="product_name">
              <FloatingInput
                className="global-global-billboard-input-feild-re-designed-re-designed"
                customStyles={floatingInputStyles}
                readOnly
              />
            </Form.Item>
          </Row>
          {productActionType == "hold_request" && (
            <>
              <Row className="campaign-hold-name-row">
                <Text
                  className="advertiser-information"
                  style={{ color: "#000", textTransform: "none" }}
                >
                  Product Start Date
                </Text>
                <Form.Item name="start_date">
                  <FloatingInput
                    className="global-global-billboard-input-feild-re-designed-re-designed"
                    customStyles={floatingInputStyles}
                    readOnly
                  />
                </Form.Item>
              </Row>
              <Row className="campaign-hold-name-row">
                <Text
                  className="advertiser-information"
                  style={{ color: "#000", textTransform: "none" }}
                >
                  Product End Date
                </Text>
                <Form.Item name="to_date">
                  <FloatingInput
                    className="global-global-billboard-input-feild-re-designed-re-designed"
                    customStyles={floatingInputStyles}
                    readOnly
                  />
                </Form.Item>
              </Row>
            </>
          )}
          <Row className="campaign-hold-name-row">
            <>
              <Text
                className="advertiser-information"
                style={{ color: "#000", textTransform: "none" }}
              >
                {productActionType == "hold_request"
                  ? "Hold Duration Date"
                  : "Select Destination Campaign"}
              </Text>

              {productActionType == "hold_request" ? (
                <>
                  <Form.Item
                    name="hold_duration_date"
                    rules={[
                      {
                        required: true,
                        message: "Please select hold duration date",
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder="Hold Duration Date"
                      className="billboard-datepicker"
                      suffixIcon={<CalenderIcon />}
                      disabledDate={disabledDate}
                      superNextIcon={false}
                      superPrevIcon={false}
                      popupClassName="start-date-calendar"
                      disabled={isHoldRequested}
                    />
                  </Form.Item>
                  {holdDurationDate && (
                    <div className="hold-expired-banner">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Text className="hold-no-of-days-count">
                          {holdDurationDays}
                        </Text>
                        <Text className="hold-no-of-days-count">Days</Text>
                      </div>
                      <div className="hold-days-divider" />
                      <div className="hold-expired-content">
                        <div
                          className={`hold-status-badge ${
                            isHoldExpired
                              ? "expired"
                              : Number(holdApprovalStatus) === 1
                                ? "approved"
                                : Number(holdApprovalStatus) === 2
                                  ? "rejected"
                                  : "in-progress"
                          }`}
                        >
                          <span className="hold-status-icon">
                            {isHoldExpired
                              ? "!"
                              : Number(holdApprovalStatus) === 1
                                ? "✓"
                                : Number(holdApprovalStatus) === 2
                                  ? "×"
                                  : "◷"}
                          </span>

                          <span>
                            {isHoldExpired
                              ? "Expired"
                              : Number(holdApprovalStatus) === 1
                                ? "Approved"
                                : Number(holdApprovalStatus) === 2
                                  ? "Rejected"
                                  : "In Progress"}
                          </span>
                        </div>
                        <div className="hold-expired-title">
                          {getHoldStatusMessage()}
                        </div>
                        <div className="hold-expired-text">
                          <div className="hold-expired-text">
                            {showHoldDates
                              ? `(${dayjs(holdStartDate).format("MMM DD, YYYY")} - ${dayjs(
                                  holdEndDate,
                                ).format("MMM DD, YYYY")})`
                              : `(${today?.format("MMM DD, YYYY")} - ${formattedSelectedHoldDate})`}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Form.Item
                    name="selected_campaign"
                    rules={[
                      {
                        required: true,
                        message: "Please select a campaign",
                      },
                    ]}
                  >
                    <FloatingSelect
                      className="billboard-select-feild"
                      border={false}
                      label={
                        <>
                          Select a campaign
                          {star}
                        </>
                      }
                      options={campaignOptions}
                      customStyles={floatingSelectStyles}
                      onChange={(value) => {
                        const selectedCampaignId = buyerCampaignsList?.find(
                          (campaign) => campaign?.productbookingid === value,
                        );
                      }}
                    />
                  </Form.Item>
                </>
              )}
            </>
          </Row>
          {productActionType == "hold_request" && (
            <Row className="campaign-hold-name-row">
              <Text
                className="advertiser-information"
                style={{ color: "#000", textTransform: "none" }}
              >
                Remarks (Optional)
              </Text>
              <Form.Item name="remarks">
                <TextArea
                  rows={4}
                  placeholder="Enter any additional information (optional)"
                  className="reason-txt-area"
                  maxLength={200}
                  showCount
                  readOnly={isHoldRequested}
                />
              </Form.Item>
            </Row>
          )}
          {sellerRejectedReason && (
            <Row className="campaign-hold-name-row">
              <Text
                className="advertiser-information"
                style={{ color: "#000", textTransform: "none" }}
              >
                Seller Rejected Reason
              </Text>
              <Form.Item name="seller_rejected_reason">
                <TextArea
                  rows={4}
                  placeholder="Enter any additional information (optional)"
                  className="reason-txt-area"
                  maxLength={200}
                  showCount
                  readOnly={isHoldRequested}
                />
              </Form.Item>
            </Row>
          )}
          <div style={{ marginTop: "1rem" }}>
            <div className="billboard-buttons-div ">
              <Button
                className="billboard-buttons billboard-button-1"
                onClick={handleCancel}
                style={{ fontSize: "14px", height: "36px" }}
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                style={{ fontSize: "14px", height: "36px" }}
                className={`billboard-buttons billboard-button-2 ${
                  isHoldRequested && productActionType === "hold_request"
                    ? "disabled-opacity"
                    : ""
                }`}
                disabled={
                  productActionType === "hold_request"
                    ? selectedProduct?.hold_approval_status >= 0
                    : false
                }
              >
                {productActionType === "hold_request"
                  ? "Submit"
                  : "Move Product"}
              </Button>
            </div>
          </div>
        </div>
      </Form>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};
export default ProductRequestHoldModal;
